import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'

import { MainGraph } from '@/pages/main/_components/graph/mainGraph'
import { MainGolfSearch } from '@/pages/main/_components/golfSearch/mainGolfSearch'
import { MainYoutube } from './_components/youtube/mainYoutube'
import { MainFeedback } from './_components/feedback/mainFeedback'
import { MainBlog } from './_components/blog/mainBlog'
import { MainSurvey } from './_components/survey/mainSurvey'
import { MainBoard } from '@/pages/main/_components/board/mainBoard'
import { NoticePopup } from '../notice/_components/noticePopup'
import { SEO } from '@/components/seo/seo'

export const MainMobile: React.FC = () => {
  const { regionAvgPrice } = useSelector(
    (state: RootState) => state.golfSearch.graphData,
  )

  return (
    <>
      <SEO
        title="꿀프"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr"
      />
      <GlobalStyle />
      <Wrapper>
        <Section>
          <MainGraph />
        </Section>
        <Section>
          <MainGolfSearch />
        </Section>
        <Section>
          <MainYoutube />
        </Section>
        <Section>
          <MainFeedback />
        </Section>
        <Section>
          <MainBlog />
        </Section>
        <Section>
          <MainSurvey />
        </Section>
        <Section>
          <MainBoard />
        </Section>
      </Wrapper>
      <NoticePopup />
    </>
  )
}

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    width: 100vw;
    overflow-x: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background-color: #fff;
  }
`

const Wrapper = styled.div`
  width: 100%;
  max-width: 480px; /* 모바일 최대 너비 제한 */
  margin: 0 auto;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
`

const Section = styled.section`
  width: 100%;
  box-sizing: border-box;
`

export default MainMobile
